module.exports = __webpack_public_path__ + "static/media/country_sc.60c99884.webp";